(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });


function formatPrice(price) {
  let priceStr = (price / 100).toFixed(2).toString();
  let [integerPart, decimalPart] = priceStr.split(".");

  let priceInt = integerPart.replace(/\D/g, "");

  if (priceInt.length === 4) {
    integerPart = priceInt.slice(0, 1) + "." + priceInt.slice(1);
  } else if (priceInt.length === 5) {
    integerPart = priceInt.slice(0, 2) + "." + priceInt.slice(2);
  } else if (priceInt.length === 6) {
    integerPart = priceInt.slice(0, 3) + "." + priceInt.slice(3);
  }

  return decimalPart !== "00"
    ? integerPart + "," + decimalPart + " Kč"
    : integerPart + " Kč";
}

function updateCartDetails() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartPriceElement = document.querySelector('.cart-pricec');
      const cartBubble = document.querySelector('.header__cart-count-number');

      if (cartPriceElement) {
        cartPriceElement.innerHTML = cart.total_price 
          ? formatPrice(cart.total_price)
          : "0 Kč";
      }

      if (cartBubble) {
        cartBubble.textContent = cart.item_count;
        cartBubble.closest('.header__cart-count').style.display = cart.item_count > 0 ? 'block' : 'none';
      }
    })
    .catch(error => console.error('Error fetching cart:', error));
}

function observeCartUpdates() {
  const priceTarget = document.querySelector('.pricing_up');
  const cartBubbleTarget = document.querySelector('#cart-icon-bubble');

  if (priceTarget) {
    new MutationObserver(updateCartDetails).observe(priceTarget, { childList: true, subtree: true, characterData: true });
    updateCartDetails();
  }

  if (cartBubbleTarget) {
    new MutationObserver(updateCartDetails).observe(cartBubbleTarget, { childList: true, subtree: true, characterData: true });
  }
}

document.addEventListener("DOMContentLoaded", observeCartUpdates);


  } catch(e) { console.error(e); }
})();
})();
